import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true, timeout: 20000 });
export const microsoftLoginUrl = `${BACKEND_URL}/api/auth/microsoft/login`;

let csrfToken = null;
export const setCsrfToken = (token) => {
  csrfToken = token;
};

const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;
export const scopeKey = () => `onsuite:scope:${localStorage.getItem("onsuite:uid") || ""}`;

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (csrfToken && !["get", "head", "options"].includes(method)) {
    config.headers["X-CSRF-Token"] = csrfToken;
  }
  if (method === "get" && localStorage.getItem(scopeKey()) === "mine" && !UUID_RE.test(config.url || "")) {
    config.headers["X-Scope"] = "mine";
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && !url.startsWith("/auth/") && window.location.pathname !== "/login") {
      window.location.assign("/login?error=session");
    }
    return Promise.reject(error);
  }
);

export const errorMessage = (error) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (detail && typeof detail.message === "string") return detail.message;
  return "Si è verificato un errore. Riprova.";
};
